const API_BASE = process.env.VUE_APP_API_URL || '/api'

const token = () => localStorage.getItem('calmdecide_token')

async function request (path, options = {}) {
  const headers = { ...(options.headers || {}) }
  if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json'
  if (token()) headers.Authorization = `Bearer ${token()}`

  const response = await fetch(`${API_BASE}${path}`, { ...options, headers })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.message || 'Something went wrong. Please try again.')
  return data
}

export const api = {
  register: payload => request('/auth/register', { method: 'POST', body: JSON.stringify(payload) }),
  login: payload => request('/auth/login', { method: 'POST', body: JSON.stringify(payload) }),
  saveDecision: payload => request('/decisions', { method: 'POST', body: JSON.stringify(payload) }),
  decisions: () => request('/decisions'),
  dashboard: () => request('/dashboard'),
  polls: () => request('/polls'),
  createPoll: payload => request('/polls', { method: 'POST', body: JSON.stringify(payload) }),
  vote: (id, choice) => request(`/polls/${id}/vote`, { method: 'POST', body: JSON.stringify({ choice }) }),
  notes: () => request('/notes'),
  createNote: payload => request('/notes', { method: 'POST', body: JSON.stringify(payload) }),
  review: (id, payload) => request(`/decisions/${id}/review`, { method: 'POST', body: JSON.stringify(payload) })
}

export function saveSession (data) {
  localStorage.setItem('calmdecide_token', data.token)
  localStorage.setItem('calmdecide_user', JSON.stringify(data.user))
}

export function getStoredUser () {
  try { return JSON.parse(localStorage.getItem('calmdecide_user')) } catch (_) { return null }
}

export function clearSession () {
  localStorage.removeItem('calmdecide_token')
  localStorage.removeItem('calmdecide_user')
}
